<!-- eslint-disable vue/order-in-components -->
<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <v-card class="py-5">
      <v-card-title>
        {{ this.$route.params.id ? $t('settings.employee.editEmployee') : $t('settings.employee.addEmployee') }}
      </v-card-title>
      <template>
        <v-form
          v-model="valid"
          @submit.prevent="submitForm()"
        >
          <v-container fluid>
            <v-row class="mx-md-16 px-md-16">
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="data.name"
                  outlined
                  :label="$t('settings.employee.employeeName')"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="data.email"
                  required
                  type="email"
                  :label="$t('settings.employee.email')"
                  outlined
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="data.role_id"
                  :items="roles"
                  :label="$t('settings.employee.role')"
                  item-text="name"
                  item-value="id"
                  outlined
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="data.mobile"
                  required
                  :label="$t('settings.employee.phone')"
                  outlined
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="data.password"
                  required
                  type="password"
                  :label="$t('settings.employee.password')"
                  outlined
                />
              </v-col>
            </v-row>
            <v-btn
              type="submit"
              class="mx-auto my-auto d-flex"
              color="indigo"
              :loading="loading"
              :disabled="disabled"
            >
              {{ this.$route.params.id ? $t('actions.save') : $t('actions.add') }}
            </v-btn>
          </v-container>
        </v-form>
      </template>
    </v-card>
    <v-snackbar
      v-model="successSnackbar"
      color="success"
      shaped
      absolute
      bottom
      right
      :timeout="timeout"
    >
      {{ successMessage }}
    </v-snackbar>
    <v-snackbar
      v-model="errorSnackbar"
      color="red"
      shaped
      absolute
      bottom
      right
      :timeout="timeout"
    >
      {{ errorMessage }}
    </v-snackbar>
  </v-container>
</template>

<script>
  // import { mapState } from 'vuex'
  import { ServiceFactory } from '@/services/ServiceFactory'
  const employeeService = ServiceFactory.get('employee')

  export default {
    name: 'Companies',
    data: (vm) => ({
      dataLoading: false,
      valid: false,
      data: {
        id: null,
        name: '',
        email: '',
        password: '',
        role_id: '',
        mobile: '',
      },
      roles: [],
      successSnackbar: false,
      errorSnackbar: false,
      timeout: 3000,
      successMessage: '',
      errorMessage: '',
      loading: false,
      disabled: false,
    }),
    created () {
      if (this.$route.params.id) {
        this.fetchOneItem(this.$route.params.id)
      }
      this.getRoles()
    },
    methods: {
      async  submitForm () {
        this.loading = true
        this.disabled = true
        const newFormData = {
          name: this.data.name,
          email: this.data.email,
          password: this.data.password,
          password_confirmation: this.data.password,
          mobile: this.data.mobile,
          role_id: this.data.role_id,
        }
        const formData = {
          id: this.data.id,
          name: this.data.name,
          email: this.data.email,
          password: this.data.password,
          mobile: this.data.mobile,
          role_id: this.data.role_id,
        }
        const employeeData = this.$store.state.employees.employee
        if (+this.$route.params.id === employeeData.id) {
          this.updateContent(this.$route.params.id, formData)
        } else {
          this.newItem(newFormData)
        }
      },
      async newItem (data) {
        const item = await employeeService.AddNewItem(data)
        try {
          if (item.status === 'success') {
            this.successMessage = 'Item Added Successfuly'
            this.successSnackbar = true
            setTimeout(() => {
              this.$router.push('/settings/employees')
            }, 1500)
          } else {
            this.errorMessage('something Error')
            this.errorSnackbar = true
          }
        } catch (err) {
          console.log('err', err.response)
          this.errorMessage('something Error')
          this.errorSnackbar = true
        }
        this.disabled = false
        this.loading = false
      },
      async updateContent (id, data) {
        const item = await employeeService.updateItem(id, data)
        try {
          if (item.status === 'success') {
            this.successMessage = 'Item Updated Successfuly'
            this.successSnackbar = true
            setTimeout(() => {
              this.$router.push('/settings/employees')
            }, 1500)
          } else {
            this.errorMessage('something Error')
            this.errorSnackbar = true
          }
        } catch (err) {
          console.log('err', err)
          this.errorMessage('something Error')
          this.errorSnackbar = true
        }
        this.disabled = false
        this.loading = false
      },
      async fetchOneItem (id) {
        this.dataLoading = true
        const employeeData = this.$store.state.employees.employee
        if (+id === employeeData.id) {
          this.data = employeeData
        }
        this.dataLoading = false
      },
      async getRoles () {
        this.dataLoading = true
        const list = await employeeService.getRolesList()
        console.log('list', list)
        this.roles = list
        this.dataLoading = false
      },
    },
  }
</script>
<style>
a{
  text-decoration: none;
}
</style>
